<template>
  <b-carousel id="carousel" :interval="5000" fade :img-height="imgHeigth" :img-width="imgWidth">
    <b-carousel-slide v-for="(image, index) in imagesSrc" :img-src="image" :key="index"></b-carousel-slide>
  </b-carousel>
</template>

<script>
import { storage } from '@/main';

export default {
  name: 'Carousel',
  components: {},
  data() {
    return {
      imageUrls: [],
    };
  },
  props: {
    images: {
      type: Array,
      default: () => [],
    },
    imagesRandom: {
      type: Boolean,
      default: false,
    },
    imgHeigth: {
      type: String,
      default: () => '300',
    },
    imgWidth: {
      type: String,
      default: () => '1200',
    },
  },
  computed: {
    style() {
      return 'width: ' + this.imgWidth + 'px; height: ' + this.imgHeigth + 'px;';
    },
    imagesSrc() {
      if (this.imageUrls.length > 0) {
        return this.imageUrls;
      }
      return this.composeImagesRandom();
    },
  },
  methods: {
    composeImagesRandom() {
      const imageUrlsRandom = [];
      if (this.imagesRandom) {
        let randomNum = Math.floor(Math.random() * 100) + 1;
        for (let i = 1; i < 6; i++) {
          imageUrlsRandom.push(
            'https://picsum.photos/' + this.imgWidth + '/' + this.imgHeigth + '?random=' + randomNum + i
          );
        }
      }
      return imageUrlsRandom;
    },
    getStorageUrls() {
      this.images.forEach(poi => {
        const storageRef = storage.ref(poi.bucket);
        storageRef
          .child('1900')
          .getDownloadURL()
          .then(url => {
            this.imageUrls.push(url);
          })
          .catch(error => {
            this.errors.push(error);
          });
      });
    },
  },
  watch: {
    images: {
      handler: function() {
        this.getStorageUrls();
      },
    },
  },
};
</script>

<style scoped></style>
